export enum AppRoutes {
  finalCheck = "final-check",
  confirmation = "confirmation",
  logout = "logout",
  loggedOut = "logged-out",
  authSignIn = "sign-in",
  authSignUp = "sign-up",
  authForgotPassword = "forgot-password",
}

export const AuthRoutes = [
  AppRoutes.authSignUp,
  AppRoutes.authSignIn,
  AppRoutes.authForgotPassword,
] as const

export type AuthRoute = (typeof AuthRoutes)[number]

export const DEFAULT_ADDITIONAL_SECTION_LIMIT = 10

export const BASE_FIELD_SPACING = 6
export const FIELD_SPACING = { base: BASE_FIELD_SPACING }

export const IDLE_TIMEOUT = 1000 * 60 * 20 // 20 minutes

export const CID_HEADER = "x-cid"

export const API_ROOT_HEADER = "x-base-url"

export const IGNORE_PREFIX = "ignore__"

export const UPLOAD_ACCEPTED_FILE_TYPES = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx"
  ]
}

export const UPLOAD_FILE_ERROR_MESSAGES = {
  required: "This field is required. Please upload a file.",
  invalidType: "Invalid file type. Please upload a .pdf, .doc, or .docx file.",
  tooLarge: "File is too large. Maximum file size is 10 MB."
}